import MaterialReactTable from 'material-react-table';
import { useState, useEffect, useMemo, useRef, useCallback } from "react";
import {Button, Box} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReportExportDropdown from './ReportExportDropdown';
import { createTableExportHandlers, sanitizeExportFilename } from '../utils/tableExportHandlers';
import Swal from 'sweetalert2';

function ReactTablePopUpMultiSelect({
    title,
    columns,
    data,
    onClose,
    onRowSubmit,
    onCSVExport,
    onExcelExport,
    onPDFExport,
    onImageExport,
    exportFilename,
    enableExportToolbar = false,
    isLoading = true,
}) {
//    console.log(JSON.stringify(data)+"data ReactTablePopUpMultiSelect");
    const [tableColumns, setTableColumns] = useState([]);
    const tableExportRef = useRef(null);
    const exportFileBase = sanitizeExportFilename(exportFilename || title || 'export');

    const defaultExportHandlers = useMemo(
        () => createTableExportHandlers({
            columns,
            records: data || [],
            title: title || 'Report',
            filename: exportFileBase,
            tableElementRef: tableExportRef,
        }),
        [columns, data, exportFileBase, title],
    );

    const handleExcelExport = useCallback(() => {
        if (onExcelExport) {
            onExcelExport();
            return;
        }
        defaultExportHandlers.onExcel();
    }, [defaultExportHandlers, onExcelExport]);

    const handlePDFExport = useCallback(() => {
        if (onPDFExport) {
            onPDFExport();
            return;
        }
        defaultExportHandlers.onPDF();
    }, [defaultExportHandlers, onPDFExport]);

    const handleImageExport = useCallback(async () => {
        try {
            if (onImageExport) {
                await onImageExport();
                return;
            }
            await defaultExportHandlers.onImage();
        } catch (error) {
            Swal.fire(error?.message || 'Image export failed.', '', 'error');
        }
    }, [defaultExportHandlers, onImageExport]);

    const exportDisabled = isLoading || !(data || []).length;
    useEffect(() => {
        // console.log('Useeffect rendered');
        const tableColumns = columns.map(col => {

            let cellAlign = col.align || 'left';
            let columnProperties = {
                accessorKey: col.fieldName,
                header: col.headerName,
                size:col.size
            };

            if (col.headerName === 'ROW_ACTIONS') {
                columnProperties = {
                    ...columnProperties,
                    header: 'Action',
                    Header: <span style={col.headerStyle}>Action</span>,
                    Cell: ({renderedCellValue,row}) => {
                        const isChecked = row.original.isChecked;
                        const isDisabled =row.original.isDisabled;
                        // console.log(isChecked+"isCheckedAction ")
                        return (
                            <span>
                                {(
                                    <input type="checkbox" onChange={(evnt)=>(onRowSubmit(renderedCellValue,evnt))} checked={isChecked || false} name="isChecked" disabled={isDisabled}/>
                                )}
                            </span>
                        );
                    }
                }
                
            } 
            else {

                if (col.headerStyle) {
                    columnProperties = {
                        ...columnProperties,
                        Header: <span style={col.headerStyle}>{col.headerName}</span>
                    };
                }

                columnProperties = {
                    ...columnProperties,
                    Cell: ({renderedCellValue}) => {

                        return (
                            <div style={{textAlign: cellAlign}}>
                                {col.dataStyle ? <span style={col.dataStyle}>{renderedCellValue}</span> : renderedCellValue}
                            </div>
                        
                        );
                    }
                };
            }

            return columnProperties;
        });

        setTableColumns(tableColumns);

    },[columns, onRowSubmit]);

    return (
        <div ref={tableExportRef} className="table-export-capture" style={{paddingTop: "10px", paddingBottom: "10px"}}>
            <h1 style={{fontSize: '22px', color: 'darkblue', fontWeight: 'bold', display:'none'}}>{title}</h1>
            <MaterialReactTable
                columns={tableColumns}
                data={data}
                enablePinning
                enableStickyHeader
                enableColumnResizing
                // enableColumnOrdering
                // enableColumnDragging
                columnResizeMode="onEnd" 
                enableColumnActions={false}
                enableColumnFilter={false}
                enablePagination={true}
                enableSorting={true}
                enableBottomToolbar={true}
                enableTopToolbar={true}
                muiTableBodyRowProps={{hover: true}}
                enableDensityToggle={true}
                state={{isLoading: isLoading}}
                muiTablePaperProps={{
                    elevation: 0,
                    sx: {
                      borderRadius: '0',
                      border: '1px solid #000000',
                    },
                  }}
                  muiTableBodyProps={{
                    sx: (theme) => ({
                      '& tr:nth-of-type(odd)': {
                        backgroundColor:'#bcbfc4',
                      },
                    }),
                  }}
                muiTableHeadCellProps={{
                    //simple styling with the `sx` prop, works just like a style prop in this example
                    sx: {
                      fontWeight: 'bold',
                      fontSize: '15px',
                      backgroundColor: '#6e8fec',
                      color:'white'
                    },
                  }}
                initialState={
                    {
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize:5},
                        columnPinning: {  left:['id']}
                    }
                }
                renderTopToolbarCustomActions={
                    () => {
                        if (enableExportToolbar) {
                            return (
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                    <Button color="primary" onClick={onClose} variant="contained">CLOSE</Button>
                                    <ReportExportDropdown
                                        onCSV={onCSVExport}
                                        onExcel={handleExcelExport}
                                        onPDF={handlePDFExport}
                                        onImage={handleImageExport}
                                        disabled={exportDisabled}
                                        label="Download"
                                    />
                                </span>
                            );
                        }
                        return (<Button color="primary" onClick={onClose} variant="contained">CLOSE</Button>);
                    }
                }
            />
        </div>
    );
}

export default ReactTablePopUpMultiSelect;

